/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bakery_Intro_List_31Inputs */

const en_bakery_intro_list_31 = /** @type {(inputs: Bakery_Intro_List_31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicate cakes turn into stamps.`)
};

const ar_bakery_intro_list_31 = /** @type {(inputs: Bakery_Intro_List_31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تتحول الكعكات المكررة إلى طوابع.`)
};

const de_bakery_intro_list_31 = /** @type {(inputs: Bakery_Intro_List_31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppelte Kuchen werden in Stempel umgewandelt.`)
};

const es_bakery_intro_list_31 = /** @type {(inputs: Bakery_Intro_List_31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los pasteles repetidos se convierten en sellos.`)
};

const fr_bakery_intro_list_31 = /** @type {(inputs: Bakery_Intro_List_31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les gâteaux en double se transforment en timbres.`)
};

const it_bakery_intro_list_31 = /** @type {(inputs: Bakery_Intro_List_31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le torte doppie si trasformano in timbri.`)
};

const ja_bakery_intro_list_31 = /** @type {(inputs: Bakery_Intro_List_31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複したケーキはスタンプに変換されます。`)
};

const ko_bakery_intro_list_31 = /** @type {(inputs: Bakery_Intro_List_31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중복된 케이크는 스탬프로 변환됩니다.`)
};

const pt_br_bakery_intro_list_31 = /** @type {(inputs: Bakery_Intro_List_31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolos repetidos se transformam em selos.`)
};

const ru_bakery_intro_list_31 = /** @type {(inputs: Bakery_Intro_List_31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторяющиеся торты превращаются в штампы.`)
};

const th_bakery_intro_list_31 = /** @type {(inputs: Bakery_Intro_List_31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เค้กที่ซ้ำกันจะเปลี่ยนเป็นแสตมป์`)
};

const tr_bakery_intro_list_31 = /** @type {(inputs: Bakery_Intro_List_31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aynı olan pastalar pullara dönüşür.`)
};

const zh_cn_bakery_intro_list_31 = /** @type {(inputs: Bakery_Intro_List_31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重复获得的蛋糕会自动转换成印花。`)
};

const zh_tw_bakery_intro_list_31 = /** @type {(inputs: Bakery_Intro_List_31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複獲得的蛋糕會自動轉換成印花。`)
};

/**
* | output |
* | --- |
* | "Duplicate cakes turn into stamps." |
*
* @param {Bakery_Intro_List_31Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
const bakery_intro_list_31 = /** @type {((inputs?: Bakery_Intro_List_31Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bakery_Intro_List_31Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bakery_intro_list_31(inputs)
	if (locale === "ar") return ar_bakery_intro_list_31(inputs)
	if (locale === "de") return de_bakery_intro_list_31(inputs)
	if (locale === "es") return es_bakery_intro_list_31(inputs)
	if (locale === "fr") return fr_bakery_intro_list_31(inputs)
	if (locale === "it") return it_bakery_intro_list_31(inputs)
	if (locale === "ja") return ja_bakery_intro_list_31(inputs)
	if (locale === "ko") return ko_bakery_intro_list_31(inputs)
	if (locale === "pt_br") return pt_br_bakery_intro_list_31(inputs)
	if (locale === "ru") return ru_bakery_intro_list_31(inputs)
	if (locale === "th") return th_bakery_intro_list_31(inputs)
	if (locale === "tr") return tr_bakery_intro_list_31(inputs)
	if (locale === "zh_cn") return zh_cn_bakery_intro_list_31(inputs)
	return zh_tw_bakery_intro_list_31(inputs)
});
export { bakery_intro_list_31 as "Bakery_intro_list_3" }